/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warning_UnterminatedInputs */

const en_warning_unterminated = /** @type {(inputs: Warning_UnterminatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A quote is not closed`)
};

const de_warning_unterminated = /** @type {(inputs: Warning_UnterminatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Anführungszeichen ist nicht geschlossen`)
};

/**
* | output |
* | --- |
* | "A quote is not closed" |
*
* @param {Warning_UnterminatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warning_unterminated = /** @type {((inputs?: Warning_UnterminatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warning_UnterminatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_warning_unterminated(inputs)
	return en_warning_unterminated(inputs)
});